import { DefaultTheme } from 'styled-components';
import { Insets } from '@digitaz/bridge-sdk-client';

export const getSafeAreaValue = (
  theme: DefaultTheme,
  edge: keyof Insets,
  base = 0,
  min?: number
) => {
  const inset = theme.webview?.insets?.[edge] ?? 0;
  const safe = min !== undefined ? Math.max(inset, min) : inset;
  const total = safe + base;

  if (theme.isWebView) {
    return `${total}px`;
  }

  return `calc(${base}px + env(safe-area-inset-${edge}))`;
};
